export default __webpack_public_path__ + "static/media/rolton.ad2e139d.png";